import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const quickLinks = [
  { to: "/", label: "首页" },
  { to: "/hot", label: "实时热点榜" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Footer() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="bg-accent-900 text-accent-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <span className="font-heading text-xl font-black leading-none">瓜</span>
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black tracking-tight text-background-50">吃瓜现场</span>
                <span className="mt-1.5 text-xs text-accent-200">免下载 · 在线看 · 实时浏览</span>
              </div>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-accent-100/90">
              聚合娱乐八卦、综艺现场与全网热讯，手机电脑自适应，网页在线看、直接打开、免下载即可实时浏览。随时随地，轻松吃瓜。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-wechat-line", "ri-weibo-line", "ri-douban-line", "ri-rss-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-accent-800/70 text-accent-50 transition-colors hover:bg-primary-500"
                  aria-hidden="true"
                >
                  <i className={`${icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>

          {/* 栏目 */}
          <div>
            <h3 className="font-heading text-base font-bold text-background-50">内容栏目</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="inline-flex items-center gap-2 text-sm text-accent-100/90 transition-colors hover:text-background-50"
                  >
                    <i className="ri-arrow-right-s-line text-primary-300" aria-hidden="true"></i>
                    {c.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/hot"
                  className="inline-flex items-center gap-2 text-sm text-accent-100/90 transition-colors hover:text-background-50"
                >
                  <i className="ri-arrow-right-s-line text-primary-300" aria-hidden="true"></i>
                  实时热点榜
                </Link>
              </li>
            </ul>
          </div>

          {/* 快速导航 */}
          <div>
            <h3 className="font-heading text-base font-bold text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="inline-flex items-center gap-2 text-sm text-accent-100/90 transition-colors hover:text-background-50"
                  >
                    <i className="ri-arrow-right-s-line text-primary-300" aria-hidden="true"></i>
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <button
                  type="button"
                  onClick={toTop}
                  className="inline-flex cursor-pointer items-center gap-2 text-sm text-accent-100/90 transition-colors hover:text-background-50"
                >
                  <i className="ri-arrow-up-s-line text-primary-300" aria-hidden="true"></i>
                  返回顶部
                </button>
              </li>
            </ul>
          </div>

          {/* 平台优势 */}
          <div>
            <h3 className="font-heading text-base font-bold text-background-50">为什么选我们</h3>
            <ul className="mt-4 space-y-3">
              {[
                { icon: "ri-eye-line", text: "免下载直接打开，点开即看" },
                { icon: "ri-smartphone-line", text: "手机版电脑版自适应切换" },
                { icon: "ri-flashlight-line", text: "热点实时刷新，随时同步" },
                { icon: "ri-lock-line", text: "无需注册，访问即得" },
              ].map((it) => (
                <li key={it.text} className="flex items-start gap-2.5 text-sm text-accent-100/90">
                  <i className={`${it.icon} mt-0.5 text-primary-300`} aria-hidden="true"></i>
                  {it.text}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-accent-700/50 pt-6 sm:flex-row">
          <p className="text-xs text-accent-200/80">
            © 2026 吃瓜现场 ChiguaXianchang · 内容仅供信息浏览与交流
          </p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-accent-200/80">
            <span>免下载 · 网页在线看</span>
            <span className="hidden sm:inline">·</span>
            <span>实时浏览 · 每日更新</span>
          </div>
        </div>
      </div>
    </footer>
  );
}